<template>
  <el-card>
    <el-row class="emoji__title">表情包管理</el-row>
    <el-tabs v-model="activeName">
      <el-tab-pane label="表情包分类" name="first">
        <!-- 搜索 -->
        <el-row class="emoji__search">
          <span>状态</span>
          <el-select v-model="emojiType.valid" clearable filterable placeholder="请选择">
            <el-option v-for="(item, index) in validList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button style="margin-left: 10px" type="success" @click="getAllEmoji">搜索</el-button>
          <el-button style="margin-left: 10px" type="primary" @click="addEmojiType(1)">上传</el-button>
        </el-row>
        <!-- 表格 -->
        <el-row>
          <el-table border :data="emojiTypeTable">
            <el-table-column prop="id" label="id" align="center">
            </el-table-column>
            <el-table-column prop="libraryName" label="分类名" align="center">
            </el-table-column>
            <el-table-column label="图标" align="center">
              <template slot-scope="scope">
                <el-image style="width: 100px; height: auto" :src="scope.row.libraryIcon"
                  :preview-src-list="[scope.row.libraryIcon]"></el-image>
              </template>
            </el-table-column>
            <el-table-column label="表情包状态" align="center">
              <template slot-scope="scope">
                {{ scope.row.valid === 0 ? '无效' : '有效' }}
              </template>
            </el-table-column>
            <el-table-column prop="orderId" label="排序id" sortable align="center">
            </el-table-column>
            <el-table-column prop="svipLevel" label="SVIP等级" align="center" sortable>
              <template slot-scope="scope">
                {{ scope.row.svipLevel === 0 ? '免费' : `SVIP${scope.row.svipLevel|| ''}` }}
              </template>
            </el-table-column>
            <el-table-column label="类型" align="center">
              <template slot-scope="scope">
                {{ scope.row.type === 0 ? '普通' : scope.row.type === 1 ? '游戏玩法' : '--' }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="primary" @click="updateEmojiType(scope.row, 1)">修改</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <!-- 弹窗 -->
        <el-dialog :show-close="false" :close-on-click-modal="false" :visible.sync="emojiTypeData.dailogShow"
          :close-on-press-escape="false" title="表情包分类管理">
          <el-row>
            <span>分类名：</span>
            <el-input v-model="emojiTypeForm.libraryName" placeholder="请输入内容"
              style="width: 200px; margin-bottom: 5px"></el-input>
          </el-row>
          <el-row>
            <span>排序id：</span>
            <el-input v-model="emojiTypeForm.orderId" placeholder="请输入内容" type="number"
              style="width: 200px; margin-bottom: 5px"></el-input>
          </el-row>
          <el-row>
            <span>表情包图标：</span>
            <el-upload class="avatar-uploader" action="#" list-type="picture-card" :show-file-list="false" :on-change="(file, fileList) =>
                changfile(file, fileList, 'emoji_lib/icon/', 1)
              " :on-remove="handleRemove(1)" :auto-upload="false">
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-row>
          <el-row>
            <span>状态：</span>
            <el-select v-model="emojiTypeForm.valid" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in validList" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-row>
          <el-row>
            <span>SVIP等级：</span>
            <el-input-number
              v-model="emojiTypeForm.svipLevel"
              :min="0"
              :max="10"
              placeholder="0表示免费，1表示SVIP1"
              style="width: 300px; margin-bottom: 5px"
            ></el-input-number>
          </el-row>
          <el-row>
            <span>类型：</span>
            <el-select v-model="emojiTypeForm.type" clearable filterable placeholder="请选择" style="width: 200px; margin-bottom: 5px">
              <el-option label="普通" :value="0"></el-option>
              <el-option label="游戏玩法" :value="1"></el-option>
            </el-select>
          </el-row>
          <el-row>
            <el-button @click="resetForm(1)">取消</el-button>
            <el-button type="primary" @click="updateEmojiTypeData">确认</el-button>
          </el-row>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="表情包列表" name="second">
        <!-- 搜索 -->
        <el-row class="emoji__search">
          <span>状态</span>
          <el-select v-model="emojiList.valid" clearable filterable placeholder="请选择">
            <el-option v-for="(item, index) in validList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <span>表情包id</span>
          <el-select v-model="emojiList.libId" clearable filterable placeholder="请选择">
            <el-option v-for="(item, index) in emojiTypeTable" :key="index" :label="item.libraryName" :value="item.id">
            </el-option>
          </el-select>
          <el-button style="margin-left: 10px" type="success" @click="getAllEmojiList(0)">搜索</el-button>
          <el-button style="margin-left: 10px" type="primary" @click="addEmojiType(2)">上传</el-button>
        </el-row>
        <!-- 表格 -->
        <el-row>
          <el-table border :data="emojiListTable">
            <el-table-column prop="id" label="id" align="center">
            </el-table-column>
            <el-table-column prop="libraryId" label="分类id" align="center">
            </el-table-column>
            <el-table-column prop="libraryName" label="分类名" align="center">
            </el-table-column>
            <el-table-column label="图标" align="center">
              <template slot-scope="scope">
                <el-image style="width: 100px; height: auto" :src="scope.row.iconUrl"
                  :preview-src-list="[scope.row.iconUrl]"></el-image>
              </template>
            </el-table-column>
            <el-table-column label="资源" align="center">
              <template slot-scope="scope">
                <el-image style="width: 100px; height: auto" :src="scope.row.originUrl"
                  :preview-src-list="[scope.row.originUrl]"></el-image>
              </template>
            </el-table-column>
            <el-table-column label="表情状态" align="center">
              <template slot-scope="scope">
                {{ scope.row.valid === 0 ? '无效' : '有效' }}
              </template>
            </el-table-column>
            <el-table-column prop="orderId" label="排序id" sortable align="center">
            </el-table-column>
            <el-table-column prop="svipLevel" label="SVIP等级" align="center" sortable>
              <template slot-scope="scope">
                {{ scope.row.svipLevel === 0 ? '免费' : `SVIP${scope.row.svipLevel}` }}
              </template>
            </el-table-column>
            <el-table-column prop="type" label="类型" align="center">
              <template slot-scope="scope">
                {{ getEmojiTypeName(scope.row.type) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="primary" @click="updateEmojiType(scope.row, 2)">修改</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <!-- 分页 -->
        <el-row>
          <el-pagination background layout="prev, pager, next" :total="emojiListData.totalPage"
            :page-size="emojiListData.pageSize" :current-page.sync="emojiListData.currentPage"
            @current-change="guaranteedHandleCurrentChange">
          </el-pagination>
        </el-row>
        <!-- 弹窗 -->
        <el-dialog :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
          :visible.sync="emojiListData.dailogShow" title="表情包列表管理">
          <el-row>
            <span>分类id：</span>
            <el-select v-model="emojiListForm.libraryId" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in emojiTypeTable" :key="index" :label="item.libraryName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-row>
          <el-row>
            <span>排序id：</span>
            <el-input v-model="emojiListForm.orderId" placeholder="请输入内容" type="number"
              style="width: 200px; margin-bottom: 5px"></el-input>
          </el-row>
          <el-row>
            <span>表情包图标：</span>
            <el-upload class="avatar-uploader" action="#" list-type="picture-card" :show-file-list="false" :on-change="(file, fileList) =>
                changfile(file, fileList, 'emoji_config/icon/', 2)
              " :on-remove="handleRemove(1)" :auto-upload="false">
              <img v-if="imagesUrl" :src="imagesUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-row>
          <el-row>
            <span>资源图片：</span>
            <el-upload class="avatar-uploader" action="#" list-type="picture-card" :show-file-list="false" :on-change="(file, fileList) =>
                changfile(file, fileList, 'emoji_config/origin/', 3)
              " :on-remove="handleRemove(1)" :auto-upload="false">
              <img v-if="imagesUrls" :src="imagesUrls" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-row>
          <el-row>
            <span>状态：</span>
            <el-select v-model="emojiListForm.valid" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in validList" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-row>
          <el-row>
            <span>SVIP等级：</span>
            <el-input-number
              v-model="emojiListForm.svipLevel"
              :min="0"
              :max="10"
              placeholder="0表示免费，1表示SVIP1"
              style="width: 200px; margin-bottom: 5px"
            ></el-input-number>
          </el-row>
          <el-row>
            <span>类型：</span>
            <el-select v-model="emojiListForm.type" clearable filterable placeholder="请选择" style="width: 200px; margin-bottom: 5px">
              <el-option v-for="(item, index) in emojiTypeList" :key="index" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-row>
          <el-row>
            <el-button @click="resetForm(2)">取消</el-button>
            <el-button type="primary" @click="updateEmojiListData">确认</el-button>
          </el-row>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import { getConstList } from '@/api/constRequest'

export default {
  data() {
    return {
      imageUrl: '',
      imagesUrl: '',
      imagesUrls: '',
      activeName: 'first',
      // 状态列表
      validList: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '无效',
          value: 0,
        },
        {
          label: '有效',
          value: 1,
        },
      ],
      // 表情包分类页数
      emojiTypeData: {
        // 弹出框是否显示
        dailogShow: false,
        // 1 修改 2 添加
        type: 0,
      },
      // 表情包列表页数
      emojiListData: {
        // 弹出框是否显示
        dailogShow: false,
        // 1 修改 2 添加
        type: 0,
        // 每页显示数量
        pageSize: 30,
        // 总页数
        totalPage: 10,
        // 当前页数
        currentPage: 0,
      },
      //表情包分类查询
      emojiType: {
        valid: null,
      },
      //表情包列表查询
      emojiList: {
        valid: null,
        libId: null,
      },
      //表情包分类
      emojiTypeForm: {
        libraryName: null,
        libraryIcon: null,
        valid: null,
        orderId: null,
        svipLevel: 0,
        type: null,
      },
      //表情包列表
      emojiListForm: {
        libraryId: null,
        valid: null,
        orderId: null,
        iconUrl: null,
        originUrl: null,
        svipLevel: 0,
        type: null,
      },
      //表情包分类表格数据
      emojiTypeTable: [],
      //表情包列表表格数据
      emojiListTable: [],
      //表情包类型列表
      emojiTypeList: [],
    }
  },
  mounted() {
    this.getAllBeforeDate()
  },
  methods: {
    // 获取所有前置数据
    async getAllBeforeDate() {
      await this.getEmojiTypeList()
      this.getAllEmoji()
      this.getAllEmojiList()
    },
    // 获取表情包类型列表
    async getEmojiTypeList() {
      try {
        const res = await getConstList('emojiType')
        if (res && res.code === 0) {
          this.emojiTypeList = res.data || []
        }
      } catch (error) {
        console.error('获取表情包类型列表失败', error)
      }
    },
    // 获取表情包类型名称
    getEmojiTypeName(value) {
      if (value === null || value === undefined) return '--'
      const item = this.emojiTypeList.find(item => item.value === value)
      return item ? item.name : '--'
    },
    // 获取所有表情包分类数据
    async getAllEmoji() {
      const { data: res } = await this.$axios({
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.emoji_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          ...this.emojiType,
        },
      })

      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.emojiTypeTable = res.data
      }
    },
    // 获取所有表情包列表数据
    async getAllEmojiList(page) {
      let pages = page || this.emojiListData.currentPage

      const { data: res } = await this.$axios({
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.emoji_list_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          ...this.emojiList,
          page: pages,
        },
      })

      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.emojiListTable = res.data.data
        this.emojiListData.totalPage = res.data.total
      }
    },
    // 表情包分类添加
    addEmojiType(type) {
      if (type === 1) {
        this.emojiTypeData.dailogShow = true
        this.emojiTypeData.type = 2
      } else {
        this.emojiListData.dailogShow = true
        this.emojiListData.type = 2
      }
    },
    // 表情包分类修改
    updateEmojiType(info, type) {
      let data = JSON.parse(JSON.stringify(info))
      if (type === 1) {
        this.emojiTypeData.dailogShow = true
        this.emojiTypeData.type = 1
        this.emojiTypeForm = data
        this.imageUrl = data.libraryIcon
      } else {
        this.emojiListData.dailogShow = true
        this.emojiListData.type = 1
        this.emojiListForm = data
        this.imagesUrl = data.iconUrl
        this.imagesUrls = data.originUrl
        this.emojiListForm.libraryId = data.id
      }
    },
    // 表情包分类数修改
    async updateEmojiTypeData() {
      this.emojiTypeForm.libraryIcon = this.imageUrl
      if (this.emojiTypeData.type === 1) {
        console.log(this.emojiTypeForm)
        const { data: res } = await this.$axios({
          method: 'POST',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          url: this.$store.getters.path.emoji_change,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
          data: this.emojiTypeForm,
        })

        if (res.code !== 0) {
          return this.$message.error(res.msg)
        } else {
          this.$message.success('修改成功')
          this.resetForm(1)
          this.getAllEmoji()
        }
      } else {
        const { data: res } = await this.$axios({
          method: 'POST',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          url: this.$store.getters.path.emoji_add,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
          data: this.emojiTypeForm,
        })

        if (res.code !== 0) {
          return this.$message.error(res.msg)
        } else {
          this.$message.success('创建成功')
          this.resetForm(1)
          this.getAllEmoji()
        }
      }
    },
    // 表情包列表数修改
    async updateEmojiListData() {
      this.emojiListForm.iconUrl = this.imagesUrl
      this.emojiListForm.originUrl = this.imagesUrls
      console.log(this.emojiListForm)
      if (this.emojiListData.type === 1) {
        const { data: res } = await this.$axios({
          method: 'POST',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          url: this.$store.getters.path.emoji_list_change,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
          data: this.emojiListForm,
        })

        if (res.code !== 0) {
          return this.$message.error(res.msg)
        } else {
          this.$message.success('修改成功')
          this.resetForm(2)
          this.getAllEmojiList()
        }
      } else {
        const { data: res } = await this.$axios({
          method: 'POST',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          url: this.$store.getters.path.emoji_list_add,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
          data: this.emojiListForm,
        })

        if (res.code !== 0) {
          return this.$message.error(res.msg)
        } else {
          this.$message.success('创建成功')
          this.resetForm(2)
          this.getAllEmojiList()
        }
      }
    },
    //修改当前页
    guaranteedHandleCurrentChange(page) {
      this.getAllEmojiList(page)
    },
    //上传图片
    async changfile(file, fileList, dir, type) {
      const formdata = new FormData()
      formdata.append('file', file.raw)
      formdata.append('cover', 0)
      formdata.append('dir', dir)
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formdata
      )

      if (res.code !== 0) {
        this.fileList = []
        return this.$message.error('文件上传失败请重新选择文件上传')
      }
      if (type === 1) {
        console.log(this.emojiTypeForm.libraryIcon)
        this.emojiTypeForm.libraryIcon = res.data
        this.imageUrl = res.data
      } else if (type === 2) {
        this.emojiListForm.iconUrl = res.data
        this.imagesUrl = res.data
      } else if (type === 3) {
        this.emojiListForm.originUrl = res.data
        this.imagesUrls = res.data
      }
    },
    // 删除图片
    handleRemove(type) {
      if (type === 1) {
        this.emojiTypeForm.libraryIcon = null
      } else if (type === 2) {
        this.emojiListForm.iconUrl = null
      } else if (type === 3) {
        this.emojiListForm.originUrl = null
      }
    },
    // 取消
    resetForm(type) {
      if (type === 1) {
        this.emojiTypeForm = {
          libraryName: null,
          libraryIcon: null,
          valid: null,
          orderId: null,
          svipLevel: 0,
          type: null,
        }
        this.imageUrl = ''
        this.emojiTypeData.dailogShow = false
      } else {
        this.emojiListForm = {
          libraryId: null,
          valid: null,
          orderId: null,
          iconUrl: null,
          originUrl: null,
          svipLevel: 0,
          type: null,
        }
        this.imagesUrl = ''
        this.imagesUrls = ''
        this.emojiListData.dailogShow = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.emoji {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }
}

.avatar-uploader {
  margin: 10px 0;

  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }

  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
}
</style>
